import { initReactI18next } from 'react-i18next';

import i18n from 'i18next';

import french from './locales/fr.json';
import english from './locales/en.json';
import { Language, languages } from '../services/config/types';

// the translations
const resources = {
  [languages[Language.French]]: {
    translation: french,
  },
  [languages[Language.English]]: {
    translation: english,
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: languages[Language.English],
    fallbackLng: 'en',
    keySeparator: '.',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
